import React from 'react';
import './App.css';
import Toolbar from './components/Toolbar';
import GraphEditor from './components/GraphEditor';
import DialogueEditor from './components/DialogueEditor';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider } from './contexts/ToastContext';

function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <div className="App h-screen flex flex-col bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
          <Toolbar />
          <div className="flex-1 flex overflow-hidden">
            <div className="flex-1 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700">
              <ErrorBoundary>
                <GraphEditor />
              </ErrorBoundary>
            </div>
            <div className="w-96 bg-gray-50 dark:bg-gray-900 overflow-y-auto">
              <ErrorBoundary>
                <DialogueEditor />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
